import React from 'react';
import { ArrowRightLeft } from 'lucide-react';
import { useCurrency } from '../../../../hooks/useCurrency';

const SystemLiveTransactions = () => {
  const { convertFromUSD, currencySymbol, formatAmountWithoutCurrency } = useCurrency();

  // Mock data
  const transactions = [
    { id: 1, sender: 'User#123', receiver: 'System', amount: 50.00, type: 'DEPOSIT' },
    { id: 2, sender: 'System', receiver: 'User#456', amount: 120.50, type: 'WITHDRAW' },
  ];

  return (
      <div className="flex-1 bg-neutral-900/40 backdrop-blur-md border border-neutral-800 rounded-lg p-5">
        <div className="flex items-center gap-2 mb-4">
          <ArrowRightLeft className="w-4 h-4 text-blue-400" />
          <h3 className="text-xs font-black uppercase tracking-widest text-white">Live Transactions</h3>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-left">
            <thead>
            <tr className="border-b border-neutral-800 text-[10px] text-neutral-500 uppercase tracking-tighter">
              <th className="pb-2">Sender</th>
              <th className="pb-2">Receiver</th>
              <th className="pb-2 text-right">Amount</th>
            </tr>
            </thead>
            <tbody className="divide-y divide-neutral-800/50">
            {transactions.map((tx) => (
                <tr key={tx.id} className="text-[11px] group hover:bg-white/[0.02]">
                  <td className="py-2 text-neutral-300 font-bold">{tx.sender}</td>
                  <td className="py-2 text-neutral-300 font-bold">{tx.receiver}</td>
                  <td className="py-2 text-right font-mono font-black text-emerald-500">
                    {currencySymbol}{formatAmountWithoutCurrency(convertFromUSD(tx.amount))}
                  </td>
                </tr>
            ))}
            </tbody>
          </table>
        </div>
      </div>
  );
};

export default SystemLiveTransactions;